import React from "react";
import { formatAppDate } from "../../../helpers/date-formatter";
import {
  ArrowDownTrayIcon,
  CloudArrowDownIcon,
  CloudArrowUpIcon,
  GiftIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import DataTable from "../../table/DataTable";
import { MediaCell } from "../../table/DataTableCell";
import StatusBadge from "../../table/StatusBadge";
import ActionGroup, { ActionButton } from "../../table/ActionGroup";

function CampaignTable({
  campaigns,
  onDelete,
  onArchive,
  onDownload,
  isArchive,
}) {
  const columns = [
    {
      key: "campaign",
      label: "Campaign",
      render: (item) => (
        <MediaCell
          src={item.imageUrl}
          alt={item.title}
          title={item.title}
          subtitle={item.description}
        />
      ),
    },
    {
      key: "startsOn",
      label: "Starts On",
      width: "140px",
      render: (item) => formatAppDate(item.startsOn),
    },
    {
      key: "endsOn",
      label: "Ends On",
      width: "140px",
      render: (item) => formatAppDate(item.endsOn),
    },
    {
      key: "status",
      label: "Status",
      width: "150px",
      render: (item) => <StatusBadge active={item.active} />,
    },
    {
      key: "createdOn",
      label: "Created On",
      width: "140px",
      render: (item) => formatAppDate(item.createdOn),
    },
    {
      key: "actions",
      label: "Actions",
      align: "right",
      width: "220px",
      render: (item) => (
        <ActionGroup>
          <ActionButton as={Link} to={`/coupon-campaign/${item.id}`} color="yellow" title="Campaign Prizes">
            <GiftIcon className="h-5 w-5" />
          </ActionButton>
          <ActionButton
            color={isArchive ? "green" : "orange"}
            onClick={() => onArchive(item)}
            title={isArchive ? "Activate" : "Archive"}
          >
            {isArchive ? (
              <CloudArrowUpIcon className="h-5 w-5" />
            ) : (
              <CloudArrowDownIcon className="h-5 w-5" />
            )}
          </ActionButton>
          <ActionButton as={Link} to={`/coupon-campaign/${item.id}/edit`} color="blue" title="Edit">
            <PencilSquareIcon className="h-5 w-5" />
          </ActionButton>
          <ActionButton color="red" onClick={() => onDelete(item)} title="Delete">
            <TrashIcon className="h-5 w-5" />
          </ActionButton>
          <ActionButton color="purple" onClick={() => onDownload(item)} title="Download coupons">
            <ArrowDownTrayIcon className="h-5 w-5" />
          </ActionButton>
        </ActionGroup>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={campaigns}
      rowKey="id"
      minWidth="980px"
      emptyMessage="No campaigns found."
    />
  );
}

export default CampaignTable;
